import {useCustomQuery} from "~/query/queryClient";
import {queryHttp} from "~/query/queryHttp";
import {supplierClusterMembersByEntityUrl} from "~/pages/supplier-360/services/supplier360Urls";
import type {SupplierClusterMember} from "~/pages/supplier-360/types/Supplier360Types";

/**
 * Every cluster member of one entity — Overview tab "Cluster" section. Unpaginated (`no_page=1`),
 * so the section's client-side filters, the source-system count and the alias list all see the
 * complete cluster, never just its first page.
 */
export function useSupplierClusterMembersByEntityQuery(entityId: number | undefined) {
    const url = supplierClusterMembersByEntityUrl(entityId ?? 0);
    return useCustomQuery({
        queryKey: [url] as const,
        queryFn: async () => (await queryHttp.get<SupplierClusterMember[]>(url)).data,
        enabled: Boolean(entityId),
    });
}
